import { OutlinedInput, RHFSelect } from '@aibees/shared/components';
import { USER_MEMBER_OPTIONS_WITHOUT_OWNER } from '@aibees/shared/components/user-role-dropdown/config';
import { classnames } from '@aibees/shared/utils';
import { MenuItem, Stack, Typography } from '@mui/material';
import { capitalize } from 'lodash-es';
import { memo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEditRoleDialogContext } from '../edit-role-dialog/context';
import * as Styled from './styles';
import * as SX from './sx';
import type { TeamMemberFormProps as Props } from './types';

export const EditRoleForm = memo(({ className, item }: Props) => {
  const { watch } = useFormContext();
  const { submitButtonDisabled } = useEditRoleDialogContext();

  const selectedType = watch().type;

  useEffect(() => {
    if (item.type !== selectedType) {
      submitButtonDisabled.onFalse();
    } else {
      submitButtonDisabled.onTrue();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, selectedType]);

  const roleOptions = USER_MEMBER_OPTIONS_WITHOUT_OWNER.map((role) => ({
    key: role,
    title: (
      <Stack direction="row" gap={0.5} alignItems="center">
        <Typography variant="body4">{`${capitalize(role)} `}</Typography>
        <Typography
          variant="body4"
          sx={SX.optionTitleParentheses({
            isNew: item.type !== role,
          })}
        >
          ({item.type === role ? 'Current Role' : 'New Role'})
        </Typography>
      </Stack>
    ),
    value: role,
  }));

  return (
    <Styled.Wrapper className={classnames('EditRoleForm', className)} gap={1}>
      <OutlinedInput
        fullWidth
        disabled
        value={item.user?.username || ''}
        startIcon="email-unread"
        size="small"
        label="Email"
      />
      <Typography variant="body4" color="grey.500" fontWeight={600}>
        Set permission profile
      </Typography>
      <RHFSelect
        name="type"
        icon="edit-role"
        size="small"
        textFieldSx={{
          '.MuiInputBase-input': {
            pl: 3,
          },
        }}
        children={roleOptions.map((i) => (
          <MenuItem key={i.key} value={i.value}>
            {i.title}
          </MenuItem>
        ))}
      />
    </Styled.Wrapper>
  );
});

EditRoleForm.displayName = 'EditRoleForm';
